import { render, staticRenderFns } from "./RequestAutoPriority.vue?vue&type=template&id=60e346a4&"
import script from "./RequestAutoPriority.vue?vue&type=script&lang=js&"
export * from "./RequestAutoPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports